
import * as React from 'react';

import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
//import { unregister } from './registerServiceWorker';
const history = createBrowserHistory();
// Get the application-wide store instance, prepopulating with state from the server where available.

export const store = configureStore(history);


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <Provider store={store}>    
      <App />
    </Provider>,

)


//unregister(); // Service Worker not required as do not need offline capabilities and it breaks cache busting for new versions
